import type { BaseStoreKeys } from '@/utils/baseStoreConfig';

export const getTimezone = (baseStore: BaseStoreKeys) => {
  const timezones = {
    fressnapfDE: 'Europe/Berlin',
    fressnapfAT: 'Europe/Vienna',
    fressnapfCH: 'Europe/Zurich',
    fressnapfLU: 'Europe/Luxembourg',
    maxizooPL: 'Europe/Warsaw',
    maxizooFR: 'Europe/Paris',
    maxizooBE: 'Europe/Brussels',
    maxizooIE: 'Europe/Dublin',
    maxizooDK: 'Europe/Copenhagen',
  };

  return timezones[baseStore] || 'Europe/Berlin';
};
